// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";

type OwnProps = $Exact<{
  department: Object,
  onSubmit: () => void,
  onClose: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class DeleteDepartmentModal extends React.Component<Props> {
  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onClose}>
          {this.props.t("DELETE_DEPARTMENT")} {((this.props.department || {}).data || {}).label}
        </ModalHeader>
        <ModalBody>{this.props.t("DELETE_DEPARTMENT_WARNING")}</ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button color="negative" onClick={this.props.onSubmit}>
            {this.props.t("DELETE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(DeleteDepartmentModal);
